class NumberButton extends HTMLElement {
  #abortController: AbortController | null = null;
  input: HTMLInputElement;
  btns: NodeListOf<HTMLButtonElement>

  constructor() {
    super();
    this.input = this.querySelector('input[type=number]') as HTMLInputElement;
    this.btns = this.querySelectorAll('button[data-icon]');
  }

  connectedCallback(): void {
    /* console.log(`NumberButton > connectedCallback`); */
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    this.btns.forEach(btn => {
      btn.addEventListener('click', (e) => this.onBtnClick(btn.dataset.icon), { signal });
    });
  }

  disconnectedCallback(): void {
    /* console.log(`NumberButton > disconnectedCallback`); */
    this.#abortController?.abort();
    this.#abortController = null;
  }

  static get observedAttributes(): string[] {
    return ['data-value'];
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
    if (name === 'data-value') {
      this.input.value = newValue;
    }
  }

  onBtnClick(icon: string | undefined) {
    if (icon === 'minus') {
      this.input.stepDown();
      this.input.dispatchEvent(new Event('input'));
    }

    if (icon === 'plus') {
      this.input.stepUp();
      this.input.dispatchEvent(new Event('input'));
    }
  }
}

customElements.define('number-button', NumberButton);